import React, { useEffect, useState } from "react";
import { profileUser, updateUserProfile } from "../api/service";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router";
import { FaStar } from "react-icons/fa";
import { BiLogOut, BiEditAlt } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
// import { CgReport } from "react-icons/cg";
import logo from "../assets/Logo.png";
import banner from "../images/banner.png";
// import ThemeSwitcher from "../components/ThemeSwitcher";

const Profile = () => {
  let token = localStorage.getItem("token");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [lati, setLati] = useState();
  const [long, setLong] = useState();
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [editable, setEditable] = useState(false);

  const navigate = useNavigate();

  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
        setName(req.data.userValidation.name);
        setEmail(req.data.userValidation.email);
        setMobile(req.data.userValidation.mobile);
      } else {
        navigate("/");
      }
    });
  };

  const clearCacheData = () => {
        caches.keys().then((names) => {
            names.forEach((name) => {
                caches.delete(name);
            });
        });
        alert("Complete Cache Cleared");
    };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);
        setLati(position.coords.latitude);
        setLong(position.coords.longitude);
      });
    } else {
      console.log("Location not available");
    }
  };

  const handleProfileUpdate = () => {
    // Implement logic to update user profile on the server
    const updatedProfile = {
      name: name,
      email: email,
      mobile: mobile,
    };

    updateUserProfile(token, updatedProfile)
      .then((res) => {
        console.log("Profile Updated Successfully:", res.data);
        setEditable(false);
      })
      .catch((error) => {
        console.error("Error updating profile:", error);
        // Handle error
      });
  };

  useEffect(() => {
    profileInit();
    getLocation();
  }, []);

  return (
    <>
      <Navbar />
      <div className="h-full p-12 dark:bg-[#161b22] bg-[#FAF7F0] text-[#161b22]  dark:text-[#FAF7F0]  flex flex-wrap items-center justify-center">
        <div className="container max-w-lg dark:bg-[#161b22] bg-[#FAF7F0] text-[#161b22]  dark:text-[#FAF7F0] rounded shadow-lg transform duration-200 easy-in-out m-12">
          <div className="h-2/4 sm:h-64  overflow-hidden">
            <img className="w-full rounded-md " src={banner} alt="Cover" />
          </div>
          <div className="flex justify-start -mt-12 mb-5 md:-mt-32 md:mb-2">
            <span className="block relative">
              <img
                alt="Profile"
                src={logo}
                className="mx-auto object-cover rounded-full p-1 h-20 w-20 md:h-32 md:w-32 bg-slate-200"
              />
              <button
                className="absolute bottom-0 right-0 p-2 bg-gray-700 text-white rounded-full"
                onClick={() => setEditable(!editable)}
              >
                <BiEditAlt size={20} />
              </button>
            </span>
          </div>
          <div className="">
            <div className="px-7 mb-8">
              <h2 className="text-3xl font-bold text-[#161b22]  dark:text-[#FAF7F0]">
                {name}
              </h2>
              <p className="text-[#39424e]  dark:text-[#FAF7F0] mt-2 text-xl border-b-2 border-gray-500 mb-4">
                {mobile}
              </p>
              <p className="mt-2 font-semibold text-xl  text-[#2d353f]  dark:text-[#FAF7F0]">
                Current Location <br />
                <span className=" mt-2 text-sm text-[#2d353f]  dark:text-[#FAF7F0]">
                  Latitude: {lati} <br /> Longitude: {long}
                </span>
              </p>
              <button
                className="justify-center px-4 py-2 cursor-pointer bg-[#5193f0] max-w-min mx-auto mt-8 rounded-lg text-[#2d353f]  dark:text-[#FAF7F0] hover:bg-[#4775b4] shadow-none hover:text-gray-100 dark:bg-gray-700  dark:hover:bg-gray-600 dark:hover:text-gray-200"
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <MdEmail size={25} /> &nbsp;{email}
                </div>
              </button>
              <br />

              {editable && (
                <button
                  className="justify-center px-4 py-2 cursor-pointer bg-[#5193f0] max-w-min mx-auto mt-8 rounded-lg text-[#2d353f]  dark:text-[#FAF7F0] hover:bg-[#4775b4] shadow-none hover:text-gray-100 dark:bg-gray-700  dark:hover:bg-gray-600 dark:hover:text-gray-200"
                  onClick={handleProfileUpdate}
                >
                  Save Profile
                </button>
              )}
            </div>
          </div>
          <button
    className="flex my-2 w-full items-center text- justify-center px-4 py-2 cursor-pointer bg-gray-200 rounded-lg text-[#2d353f]  dark:text-[#FAF7F0] hover:bg-gray-300 shadow-none hover:text-gray-500 dark:bg-gray-700  dark:hover:bg-gray-600 dark:hover:text-gray-200"
    onClick={() => navigate("/donation")}
  >
    <span className="ml-2">Donate to the Relief fund</span>
  </button>
          <div className="flex justify-center items-center space-x-4 mt-8">

  <button
    className="flex my-2 w-full items-center text- justify-center px-4 py-2 cursor-pointer bg-gray-200 rounded-lg text-[#2d353f]  dark:text-[#FAF7F0] hover:bg-gray-300 shadow-none hover:text-gray-500 dark:bg-gray-700  dark:hover:bg-gray-600 dark:hover:text-gray-200"
    onClick={() => navigate("/overview")}
  >
    <span className="ml-2">News Report</span>
  </button>

  <button
    className="flex my-2 w-full items-center text- justify-center px-4 py-2 cursor-pointer bg-gray-200 rounded-lg text-[#2d353f]  dark:text-[#FAF7F0] hover:bg-gray-300 shadow-none hover:text-gray-500 dark:bg-gray-700  dark:hover:bg-gray-600 dark:hover:text-gray-200"
    onClick={() => clearCacheData()}
  >
    <span className="ml-2">Clear Cache</span>
  </button>
</div>

        </div>
      </div>
      
    </>
  );
};

export default Profile;
